'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PageWrapper = require('../../components/layout/PageWrapper.js');
var Button = require('@narvar/nth-block-button');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Paragraph = require('@narvar/nth-bit-paragraph');
var DesktopWorkflowContent = require('../../components/layout/DesktopWorkflowContent.js');
var ItemPhotosUploadButton = require('./ItemPhotosUploadButton.js');
var styled = require('styled-components');
var ErrorBanner = require('../../components/ErrorBanner.js');
var ItemPhotosList = require('./ItemPhotosList.js');
var ItemCardClaims = require('../../components/ItemCardClaims.js');
var SecondaryButton = require('../../components/SecondaryButton.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Spacer = styled__default["default"].div.withConfig({
  componentId: "sc-i5mxeq-0"
})(["padding-bottom:1rem;"]);
const ItemPhotoDesktop = _ref => {
  let {
    photos,
    itemDetails,
    claimDetails,
    onRemovePhoto,
    onChangeFile,
    onSubmit,
    onBack,
    error,
    computedTranslations
  } = _ref;
  const {
    claimsButtonBack,
    claimsButtonNext,
    claimsPhotoUploadDescription
  } = nthHookTranslations.useTranslations();
  const {
    photoUploadTitle
  } = computedTranslations;
  return /*#__PURE__*/React__default["default"].createElement(PageWrapper["default"], null, /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContent, null, /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContentLeft, null, /*#__PURE__*/React__default["default"].createElement(ItemCardClaims["default"], {
    itemDetails: itemDetails,
    claimDetails: claimDetails,
    layout: "vertical"
  })), /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContentRight, null, /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContentHeader, null, photoUploadTitle), /*#__PURE__*/React__default["default"].createElement(ItemPhotosUploadButton["default"], {
    onChangeFile: onChangeFile
  }), /*#__PURE__*/React__default["default"].createElement(Spacer, null, /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], null, claimsPhotoUploadDescription)), error && /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, error), /*#__PURE__*/React__default["default"].createElement(ItemPhotosList["default"], {
    photos: photos,
    onRemovePhoto: onRemovePhoto
  }), /*#__PURE__*/React__default["default"].createElement(DesktopWorkflowContent.DesktopWorkflowContentActionButtonsContainer, null, /*#__PURE__*/React__default["default"].createElement(SecondaryButton["default"], {
    big: true,
    onClick: onBack
  }, claimsButtonBack), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    disabled: Boolean(!(photos !== null && photos !== void 0 && photos.length)),
    onClick: onSubmit
  }, claimsButtonNext)))));
};
var ItemPhotoDesktop$1 = nthHookTranslations.withTranslationsProvider(ItemPhotoDesktop, {
  translationKeys: ['claimsButtonBack', 'claimsButtonNext', 'claimsPhotoUploadDescription']
});

exports["default"] = ItemPhotoDesktop$1;
